import { render, staticRenderFns } from "./Constructor.vue?vue&type=template&id=0a034d03"
import script from "./Constructor.vue?vue&type=script&lang=ts"
export * from "./Constructor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports